import * as S from './PriceValue.style';
import { useTranslation } from 'react-i18next';
import { PriceValueProps } from './PriceValue.types';
import { i18translation } from 'locale/translations/i18NsPaths';

const PriceValue = ({
  value,
  priceSuffix = 'hour',
  className,
  size = 'large',
  dataTestId
}: PriceValueProps) => {
  const keyPrefix = i18translation.createSubscription.pro;
  const { t } = useTranslation();
  const suffixText = t(keyPrefix[priceSuffix === 'hour' ? 'hr' : 'month']);

  return (
    <S.PriceValueContainer className={className} data-testid={dataTestId}>
      <S.Price size={size}>{`$${value.toLocaleString('en')}`}</S.Price>
      {suffixText}
    </S.PriceValueContainer>
  );
};

export default PriceValue;
